;(function ( $ ) {


    'use strict';

    // Create the defaults once
    var pluginName = 'parallelScroll';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.target = $('.'+$(this.element).attr('data-target-class'));
            $(this.element).parent().css({'width': '100%', 'overflow-x': 'auto'});
            $(this.element).css({width: this.target.outerWidth(), height: '1px'});
            this.registerEvents();
        },

        registerEvents: function() {
            var _this = this;
            
            $(window).on('resize', function (e) {
                $(this.element).css({width: $(this.target).outerWidth()});
            });

            $(this.element).parent().scroll(function(){
                $(_this.target).parent().scrollLeft($(this).scrollLeft());
            });
            $(this.target).parent().scroll(function(){
                $(_this.element).parent().scrollLeft($(this).scrollLeft());
            });

               
        },

        
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
